import {
  HomeHeroCover,
  Slimminghome,
  DermaOfficeImage1,
  DermaOfficeImage2,
  DermaOfficeImage3,
  Skincarehome,
  Haircarehome,
} from "../assets/data/Imagedata";
import DermaSlimVideo from "../assets/Home/DermaSlimVideo.mp4";
import DERMASTAMO from "../assets/dermastamp.svg";
import LogoLoader from "../components/LogoLoader";
import {
  FaCheckSquare,
  FaUserMd,
  FaHeart,
  FaUsers,
  FaClinicMedical,
  FaShieldAlt,
  FaAward,
} from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";
import { useEffect, useState } from "react";
import ServicesTab from "../components/ServicesTab";

import InstagramSection from "../components/InstagramSection";

const HomeTitle = () => {
  const [loading, setLoading] = useState(true);

  const features = [
    {
      icon: FaUserMd,
      title: "Doctor-Led Expertise",
      description:
        "Every consultation and treatment is supervised by trained medical professionals for your safety and satisfaction.",
    },
    {
      icon: FaHeart,
      title: "No Harsh Restrictions",
      description:
        "We believe in food freedom and realistic results — no crash diets or unhealthy regimens.",
    },
    {
      icon: FaUsers,
      title: "Inclusive & Non-Judgmental",
      description:
        "We welcome all age groups and body types with warmth, care, and complete confidentiality.",
    },
    {
      icon: FaClinicMedical,
      title: "Clinical Excellence",
      description:
        "Experience the perfect blend of medical precision and professional care under one roof.",
    },
    {
      icon: FaShieldAlt,
      title: "Safe & Proven Methods",
      description:
        "All treatments follow strict medical protocols with proven results and safety standards.",
    },
    {
      icon: FaAward,
      title: "Premium Quality Care",
      description:
        "Committed to delivering exceptional service with attention to every detail for your wellness journey.",
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LogoLoader isLoading={loading} />;

  return (
    <main className="lg:mx-4 overflow-hidden">
      {/* Hero Section */}
      <section className="relative w-full min-h-[80vh] overflow-hidden rounded-xl">
        {/* MULTIPLE DERMASTAMPS AS BACKGROUND DECORATION */}
        <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
          {/* STAMP USING VIEWPORT UNITS FOR MAXIMUM COVERAGE */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10">
            <img
              src={DERMASTAMO}
              alt="Dermastamp decorative element"
              className="w-[180vw] h-[180vw] md:w-[180vw] md:h-[180vw] lg:w-[180vw] lg:h-[180vw] max-w-[1400px] max-h-[1400px]"
              style={{
                animation: "rotateStamp 15s linear infinite",
              }}
            />
          </div>
        </div>

        {/* BACK TITLE — TOP (BEHIND IMAGE) */}
        <div className="absolute top-5 sm:top-5 inset-x-0 z-10 flex justify-center pointer-events-none">
          <h1 className="text-[36px]  md:text-[70px] lg:text-[120px] font-bold text-primary text-center leading-none">
            Body, Skin, Hair & Dental
          </h1>
        </div>

        {/* IMAGE — CENTER */}
        <div
          className="absolute inset-0 z-20 md:mt-6 mt-20"
          style={{
            backgroundImage: `url(${HomeHeroCover})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />

        {/* FRONT CONTENT — BOTTOM OF IMAGE */}
        <div className="absolute bottom-6 inset-x-0 z-40 flex px-4">
          <div className=" max-w-6xl">
            <p className="text-[36px] font-bold text-primary text- leading-none">
              Where medical expertise meets professional care.
            </p>

            <p className="mt-2 text-sm md:text-lg text-primary">
              Doctor-led aesthetic care, rejuvenation therapies, and wellness
              treatments designed to help you glow with confidence.
            </p>

            <div className="mt-6">
              <a
                href="/contactus"
                className="inline-flex items-center gap-2 bg-primary text-secondary px-7 py-3 rounded-lg font-semibold hover:bg-secondary hover:text-primary transition-all duration-300 shadow-xl"
              >
                Book Appointment
                <MdArrowOutward className="text-lg" />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-[#fdeee8] py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* SLIMMING – BIG CARD */}
            <div className="lg:col-span-2">
              <div className="rounded-3xl overflow-hidden bg-transparent">
                <img
                  src={Slimminghome}
                  alt="Slimming"
                  className="w-full h-[360px] object-cover rounded-3xl"
                />

                <div className="mt-6">
                  <h3 className="text-5xl font-semibold text-gray-700 mb-3">
                    Slimming
                  </h3>
                  <p className="text-lg text-gray-600 mb-3">
                    Lose weight and feel great <br />
                    <a
                      href="/services/slimming/slimming-weight-management"
                      className="text-gray-500 text-sm underline underline-offset-4 hover:text-gray-700"
                    >
                      Learn More
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* SKIN CARE */}
            <div className="lg:col-span-1">
              <div className="rounded-3xl overflow-hidden bg-transparent">
                <img
                  src={Skincarehome}
                  alt="Skin Care"
                  className="w-full h-[360px] object-cover rounded-3xl"
                />

                <div className="mt-6">
                  <h3 className="text-4xl font-semibold text-gray-700 mb-3">
                    Skin Care
                  </h3>
                  <p className="text-lg text-gray-600 mb-3">
                    Reveal your natural beauty
                    <br />
                    <a
                      href="/services/hair-care/hair-care-restoration"
                      className="text-gray-500 text-sm underline underline-offset-4 hover:text-gray-700"
                    >
                      Learn More
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* HAIR */}
            <div className="lg:col-span-1">
              <div className="rounded-3xl overflow-hidden bg-transparent">
                <img
                  src={Haircarehome}
                  alt="Hair"
                  className="w-full h-[360px] object-cover rounded-3xl"
                />

                <div className="mt-6">
                  <h3 className="text-4xl font-semibold text-gray-700 mb-3">
                    Hair
                  </h3>
                  <p className="text-lg text-gray-600 mb-3">
                    Achieve a bright smile
                    <br />
                    <a
                      href="/slimming"
                      className="text-gray-500 text-sm underline underline-offset-4 hover:text-gray-700"
                    >
                      Learn More
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            <div className="lg:w-1/2 w-full">
              {/* Photo Collage Style - Responsive */}
              <div className="relative h-[300px] sm:h-[350px] md:h-[400px] lg:h-[500px] w-full">
                {/* Main central image - slightly rotated */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4/5 h-3/5 sm:h-2/3 md:h-3/4 rounded-xl lg:rounded-2xl overflow-hidden shadow-lg lg:shadow-2xl z-20 rotate-2 lg:rotate-3 hover:rotate-0 transition-transform duration-300">
                  <img
                    src={DermaOfficeImage1}
                    alt="DermaSlim Wellness Clinic - Main Facility"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>

                {/* Top-left image - rotated opposite direction */}
                <div className="absolute top-2 left-2 sm:top-4 sm:left-4 w-1/3 h-1/3 sm:w-2/5 sm:h-2/5 rounded-lg lg:rounded-xl overflow-hidden shadow-md lg:shadow-2xl z-30 -rotate-6 hover:rotate-0 transition-transform duration-300 border-2 sm:border-4 border-white">
                  <img
                    src={DermaOfficeImage2}
                    alt="DermaSlim Wellness Clinic - Treatment Room"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent"></div>
                </div>

                {/* Bottom-right image - rotated opposite direction */}
                <div className="absolute bottom-2 right-2 sm:bottom-4 sm:right-4 w-1/3 h-1/3 sm:w-2/5 sm:h-2/5 rounded-lg lg:rounded-xl overflow-hidden shadow-md lg:shadow-2xl z-30 -rotate-3 hover:rotate-0 transition-transform duration-300 border-2 sm:border-4 border-white">
                  <img
                    src={DermaOfficeImage3}
                    alt="DermaSlim Wellness Clinic - Consultation Area"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-tl from-primary/10 to-transparent"></div>
                </div>

                {/* Decorative frame lines - only on larger screens */}
                <div className="hidden md:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full border-2 border-secondary/30 rounded-3xl pointer-events-none z-0"></div>
                <div className="hidden md:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[85%] h-[75%] border border-primary/20 rounded-2xl pointer-events-none z-0"></div>
              </div>
            </div>

            <div className="lg:w-1/2 w-full mt-8 lg:mt-0">
              <h3 className="text-lg font-semibold text-primary mb-2">
                About Us
              </h3>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Welcome to DermaSlim Wellness
              </h2>

              <div className="text-gray-600 leading-relaxed mb-6">
                <p>
                  Founded by Dr. Beesetty Pavani Satya Sai Malathi, along with
                  Mrs. Afshagul, DermaSlim Wellness was created to make holistic
                  beauty accessible, safe, and emotionally fulfilling for
                  everyone.
                </p>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  Our 4-step ritual
                </h3>
                <div className="space-y-3">
                  {["Analyze", "Prevent", "Treat", "Maintain"].map(
                    (step, index) => (
                      <div key={step} className="flex items-center gap-3">
                        <div className="w-6 h-6 bg-secondary rounded flex items-center justify-center">
                          <FaCheckSquare className="text-primary text-sm" />
                        </div>
                        <span className="text-gray-700 font-medium">
                          {step}
                        </span>
                      </div>
                    ),
                  )}
                </div>
              </div>

              <div className="flex gap-4 mb-8">
                <a
                  href="/aboutus"
                  className="bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
                >
                  About Us
                </a>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { value: "7+", label: "Years Experience" },
                  { value: "100%", label: "Patient Satisfaction" },
                  { value: "20+", label: "Team Members" },
                  { value: "15K+", label: "Successful Treatments" },
                ].map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-xl sm:text-2xl font-bold text-primary mb-1">
                      {stat.value}
                    </div>
                    <div className="text-xs sm:text-sm text-gray-600">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <ServicesTab />

      {/* Why Choose Us */}
      <section className="py-16 bg-secondary">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose DermaSlim Wellness
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Experience the difference with our unique approach that combines
              medical excellence with compassionate care.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-6 shadow-sm border hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 bg-secondary rounded-lg flex items-center justify-center mb-4">
                  <feature.icon className="text-xl text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram */}
      <InstagramSection />

      {/* Doctor Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row gap-8 items-center">
            <div>
              <h3 className="text-lg font-semibold text-primary mb-2">
                Expert Care
              </h3>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Dr. Beesetty Pavani Satya Sai Malathi
              </h2>
              <div className="text-gray-600 leading-relaxed mb-6">
                <p>
                  Dr. Beesetty Pavani brings extensive expertise in Dental
                  Cosmetology and Wellness, maintaining the highest standards of
                  medical confidentiality and ethics.
                </p>
              </div>

              <div className="space-y-4">
                {[
                  {
                    icon: FaUserMd,
                    title: "Personalized, Compassionate Care",
                    description:
                      "Starting with thorough analysis and customized plans for preventive care.",
                  },
                  {
                    icon: FaHeart,
                    title: "Comprehensive Care for All Wellness Needs",
                    description:
                      "Beyond clinical treatments, providing comprehensive counseling and advanced technologies.",
                  },
                  {
                    icon: FaAward,
                    title: "Expertise & Excellence",
                    description:
                      "Years of specialized training and practical experience in cosmetic and wellness treatments.",
                  },
                ].map((feature, index) => (
                  <div key={index} className="flex gap-4">
                    <div className="flex-shrink-0 w-10 h-10 bg-secondary rounded-lg flex items-center justify-center">
                      <feature.icon className="text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">
                        {feature.title}
                      </h4>
                      <p className="text-gray-600 text-sm">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How We Work - Enhanced */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50/50 relative overflow-hidden">
        {/* Background Patterns */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-secondary/20 to-transparent rounded-full mix-blend-multiply filter blur-3xl opacity-30"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tr from-primary/10 to-transparent rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>

        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-4 h-4 bg-primary rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-6 h-6 bg-secondary rounded-full"></div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-12 lg:mb-16">
            <div className="inline-flex items-center justify-center gap-2 mb-4">
              <div className="w-3 h-3 bg-primary rounded-full animate-pulse"></div>
              <h3 className="text-lg font-semibold text-primary">
                Our Process
              </h3>
              <div className="w-3 h-3 bg-primary rounded-full animate-pulse"></div>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              <span className="relative">Our 4-Step</span>
              <br />
              <span className="text-primary">Ritual Approach</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              We follow a proven 4-step ritual for all our services to ensure
              maximum benefit from your treatments through correct diagnosis and
              personalized care.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            {/* Left Side - Video Reel */}
            <div className="lg:w-1/2 w-full">
              <div className="relative group">
                {/* Video Container */}
                <div className="relative rounded-3xl overflow-hidden shadow-2xl transform transition-all duration-500 group-hover:shadow-3xl">
                  {/* YouTube iframe with optimized aspect ratio */}
                  <div className="relative pb-[177.77%] h-0">
                    {" "}
                    {/* 9:16 aspect ratio */}
                    <video
                      className="absolute top-0 left-0 w-full h-full rounded-3xl object-cover"
                      src={DermaSlimVideo}
                      autoPlay
                      muted
                      loop
                      playsInline
                    ></video>
                  </div>

                  {/* Video Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
                </div>

                {/* Video Description */}
                <div className="mt-6 text-center">
                  <p className="text-gray-600 text-sm">
                    Watch how our approach transforms lives
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side - Process Steps */}
            <div className="lg:w-1/2 w-full">
              <div className="relative">
                {/* Process Steps Grid */}
                <div className="grid grid-cols-1 gap-6">
                  {[
                    {
                      step: "01",
                      title: "Analyze",
                      description:
                        "In-depth consultation to understand and analyze the root cause of your concerns.",
                      icon: "🔍",
                    },
                    {
                      step: "02",
                      title: "Prevent",
                      description:
                        "Holistic plan including homecare routines to improve your condition and prevent future issues.",
                      icon: "🛡️",
                    },
                    {
                      step: "03",
                      title: "Treat",
                      description:
                        "Result-oriented in-clinic services tailored to your specific wellness goals.",
                      icon: "💊",
                    },
                    {
                      step: "04",
                      title: "Maintain",
                      description:
                        "Regular maintenance and personalized homecare for long-term success and wellness.",
                      icon: "🔄",
                    },
                  ].map((item, index) => (
                    <div key={index} className="group relative">
                      {/* Step Card */}
                      <div className="relative bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl hover:border-primary/30 transition-all duration-300 transform hover:-translate-y-1">
                        {/* Step Number Background */}
                        <div className="absolute -top-4 left-6">
                          <div className="relative">
                            <div className="w-8 h-8 bg-gradient-to-br from-primary to-primary/80 rounded-lg rotate-45"></div>
                            <span className="absolute inset-0 flex items-center justify-center text-white font-bold text-xs">
                              {item.step}
                            </span>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="flex items-start gap-4">
                          {/* Icon */}
                          <div className="flex-shrink-0">
                            <div className="w-12 h-12 bg-gradient-to-br from-secondary/20 to-secondary/10 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                              <span className="text-xl">{item.icon}</span>
                            </div>
                          </div>

                          {/* Text Content */}
                          <div className="flex-1">
                            <div className="flex items-center justify-between mb-2">
                              <h3 className="text-xl font-bold text-gray-900 group-hover:text-primary transition-colors duration-300">
                                {item.title}
                              </h3>
                              <div className="text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                <svg
                                  className="w-5 h-5"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M9 5l7 7-7 7"
                                  />
                                </svg>
                              </div>
                            </div>
                            <p className="text-gray-600 leading-relaxed">
                              {item.description}
                            </p>
                          </div>
                        </div>

                        {/* Bottom Accent Line */}
                        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-2xl"></div>
                      </div>

                      {/* Connecting Line (for visual flow) */}
                      {index < 3 && (
                        <div className="absolute left-6 top-full w-0.5 h-6 bg-gradient-to-b from-primary/20 to-transparent -z-10"></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HomeTitle;
